import Component from '../abstracts/Component';

export default class FixedMediaComponent extends Component {

  get SELECTORS() {
    return {
      main: '[data-fixedmedia]:not([data-fixedmedia=""])',
      fixedMedia: '.js-fixed-media'
    };
  }

  get CLASSES() {
    return {
      almostIn: 'fixed-media'
    };
  }

  constructor() {
    super();
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      entry.target.classList.toggle('media-stuck', entry.intersectionRatio > 0);
      let media = entry.target.querySelector('.js-fixed-media');
      let topPosition = document.querySelector('.main-header').clientHeight;
      media.style.top = entry.intersectionRatio > 0 ? `${topPosition}px` : '';
      media.style.left = entry.intersectionRatio > 0 ? `${media.offsetLeft}px` : '';
    });
  }

  getMediaSize(src) {
    return new Promise((resolve, reject) => {
      try {
        const img = new Image();
        img.src = src;
        img.onload = function () {
          resolve({
            width: this.width,
            height: this.height,
            src: src
          })
        }
      } catch (e) {
        reject()
      }
    });
  }

  bindResize() {
    this.$on('resize.fixedmedia', () => {
      this.applyBackground();
    });
  }

  applyBackground() {
    const elements = document.querySelectorAll(this.SELECTORS.main);

    elements.forEach(el => {
      const img = el.querySelector('picture img');
      const fixedMedia = el.querySelector(this.SELECTORS.fixedMedia);
      const currentSrc = img.currentSrc;
      const height = img.clientHeight;
      fixedMedia.style.height = `${height}px`;
      fixedMedia.style.backgroundImage = `url('${currentSrc}')`;

      el.classList.add('image-loaded');
    });
  }

  render() {

    if (document.querySelectorAll(this.SELECTORS.main) && this.$matchMedia(null, 'sm')) {
      this.applyBackground();
      this.bindResize();
    }
  }
}
